import { AllocatePromotionalDollarsMutationVariables, TransactionTime } from "@ctypes";

import { useMutation } from "@apollo/client";
import { AllocatePromotionalDollarsMutation } from "@ctypes";
import { ALLOCATE_PROMOTIONAL_DOLLARS } from "@graphql/mutations";
import { PROMOTIONAL_DOLLAR_QUERY, TRANSACTIONS } from "@graphql/queries";
import { DEFAULT_SIZE } from "@hooks/transfers";

export const useAllocatePromotionalDollars = () => {
  return useMutation<
    AllocatePromotionalDollarsMutation,
    AllocatePromotionalDollarsMutationVariables
  >(ALLOCATE_PROMOTIONAL_DOLLARS, {
    refetchQueries: [
      {
        query: TRANSACTIONS,
        variables: {
          size: DEFAULT_SIZE,
          time: TransactionTime.Past,
        },
      },
      {
        query: PROMOTIONAL_DOLLAR_QUERY,
      },
    ],
    awaitRefetchQueries: true,
  });
};
